import { handleValidationChange } from "../CommonValidation";

export const validateSalesQuotation = (data, items, setIsError) => {
    var isValid = true;

    if(data.customer_id === "" || data.customer_id === undefined) {
        handleValidationChange("customer_id", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("customer_id", false, setIsError);
    }

    if(data.contact_no === "" || data.contact_no === undefined) {
        handleValidationChange("contact_no", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("contact_no", false, setIsError);
    }

    if(data.branch_id === "" || data.branch_id === undefined) {
        handleValidationChange("branch_id", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("branch_id", false, setIsError);
    }

    if(data.valid_to === "" || data.valid_to === undefined) {
        handleValidationChange("valid_to", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("valid_to", false, setIsError);
    }

    if(data.delivery_date === "" || data.delivery_date === undefined) {
        handleValidationChange("delivery_date", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("delivery_date", false, setIsError);
    }

    if(data.ship_via === "" || data.ship_via === undefined) {
        handleValidationChange("ship_via", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("ship_via", false, setIsError);
    }

    if(items.length <= 0) {
        handleValidationChange("items", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("items", false, setIsError);
    }

    return isValid
}
// to check if sales items required filleds have data
export const validateSalesItems = (items) => {
        const errors = {};
        // const finalItems = []
        items.map((item, itemIndex) => {
        if ((!item.hasOwnProperty('description') || ((item.hasOwnProperty('description') && !item.description))) 
            && (item.item_id === '' || item.item_id === null || item.item_id === undefined)) {
            errors[itemIndex] = {
            ...errors[itemIndex],
            description: 'Item or description is required',
            };
        }

        if (!(item.qty.toString())||item.qty==='') {
            errors[itemIndex] = {
            ...errors[itemIndex],
            qty: 'Qty is required',
            };
        }

        if (!(item.unit.toString())||item.unit==='') {
            errors[itemIndex] = {
            ...errors[itemIndex],
            unit: 'Unit is required',
            };
        }

        if (!item.price) {
            errors[itemIndex] = {
            ...errors[itemIndex],
            price: 'Price is required',
            };
        }

        });

        return errors;

}



export const validateSalesOrder = (data, items, setIsError) => {
    var isValid = true;

    if(data.customer_id === "" || data.customer_id === undefined) {
        handleValidationChange("customer_id", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("customer_id", false, setIsError);
    }

    if(data.branch_id === "" || data.branch_id === undefined) {
        handleValidationChange("branch_id", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("branch_id", false, setIsError);
    }

    if(data.address === "" || data.address === undefined) {
        handleValidationChange("address", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("address", false, setIsError);
    }

    if(data.delivery_date === "" || data.delivery_date === undefined) {
        handleValidationChange("delivery_date", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("delivery_date", false, setIsError);
    }

    if(data.ship_via === "" || data.ship_via === undefined) {
        handleValidationChange("ship_via", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("ship_via", false, setIsError);
    }

    // if(data.invoice_no === "" || data.invoice_no === undefined) {
    //     handleValidationChange("invoice_no", true, setIsError);
    //     isValid=false;
    // } else {
    //     handleValidationChange("invoice_no", false, setIsError);
    // }

    items?.map((data) => {
        //
        if ((data.description === "" || data.description === undefined) && 
            (data.item_id === "" || data.item_id === undefined || data.item_id === 0)) {
            handleValidationChange("description", true, setIsError);
            isValid = false;
        } else {
            handleValidationChange("description", false, setIsError);
        }
        if (data.price === "" || data.price === undefined || data.price === 0) {
            handleValidationChange("price", true, setIsError);
            isValid = false;
        } else {
            handleValidationChange("price", false, setIsError);
        }
        if (data.qty === "" || data.qty === undefined || data.qty === 0) {
            handleValidationChange("qty", true, setIsError);
            isValid = false;
        } else {
            handleValidationChange("qty", false, setIsError);
        }
    });

    return isValid
  
}


export const validateSalesInvoice = (data, items, setIsError) => {
    var isValid = true;

    if(data.customer_id === "" || data.customer_id === undefined) {
        handleValidationChange("customer_id", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("customer_id", false, setIsError);
    }

    if(data.branch_id === "" || data.branch_id === undefined) {
        handleValidationChange("branch_id", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("branch_id", false, setIsError);
    }
    

    if(data.address === "" || data.address === undefined) {
        handleValidationChange("address", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("address", false, setIsError);
    }

    if(data.delivery_date === "" || data.delivery_date === undefined) {
        handleValidationChange("delivery_date", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("delivery_date", false, setIsError);
    }

    if(data.ship_via === "" || data.ship_via === undefined) {
        handleValidationChange("ship_via", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("ship_via", false, setIsError);
    }

    if(data.release_from === "" || data.release_from === undefined) {
        handleValidationChange("release_from", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("release_from", false, setIsError);
    }

    if(data.release_by === "" || data.release_by === undefined) {
        handleValidationChange("release_by", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("release_by", false, setIsError);
    }

    items?.map((data) => {
        //
        if ((data.item_id === "" || data.item_id === undefined || data.item_id === null)) {
            handleValidationChange("item_id", true, setIsError);
            isValid = false;
        } else {
            handleValidationChange("item_id", false, setIsError);
        }
        if (data.price === "" || data.price === undefined || data.price === 0) {
            handleValidationChange("price", true, setIsError);
            isValid = false;
        } else {
            handleValidationChange("price", false, setIsError);
        }
        if (data.qty === "" || data.qty === undefined || data.qty === 0) {
            handleValidationChange("qty", true, setIsError);
            isValid = false;
        } else {
            handleValidationChange("qty", false, setIsError);
        }
    });

    return isValid
  
}

// to check if sales items required filleds have data
export const validateSalesInvoiceItems = (items) => {
        const errors = {};
        // const finalItems = []
        items.map((item, itemIndex) => {
        if (item.item_id === '' || item.item_id === null || item.item_id === undefined) {
            errors[itemIndex] = {
            ...errors[itemIndex],
            item_id: 'Item is required',
            };
        }

        if (!(item.qty.toString())|| (parseInt(item.qty) <= 0)) {
          errors[itemIndex] = {
            ...errors[itemIndex],
            qty: 'Qty is required and make sure it is greater than 0',
          };
        }

        // if (!(item.unit.toString())||item.unit==='') {
        //     errors[itemIndex] = {
        //     ...errors[itemIndex],
        //     unit: 'Unit is required',
        //     };
        // }

        if (!(item.price.toString()) || (parseInt(item.price) <= 0)) {
          errors[itemIndex] = {
            ...errors[itemIndex],
            price: 'Price is required and make sure it is greater than 0',
          };
        }

        });

        return errors;

}